<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(print)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="success" @click="save"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :edit-config="{}"
        :edit-rules="editRules"
        :loading="loading"
        keep-source>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="print.name" title="business.label.printName"/>
        <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="mac" title="business.label.mac"/>
        <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="host" title="business.label.host"/>
        <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="ip" title="business.label.ip"/>
        <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="printer" title="business.label.printer"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { deleteOne, findAll, saveAll } from '@/api/Api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { PrintConfig } from '@/api/dto/config/PrintConfig'
import { Print } from '@/api/dto/admin/Print'

export default {
  name: 'PrintConfig',
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      print: new Print(),
      page: 1,
      size: 20,
      contentSize: 0,
      editRules: {
        mac: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        host: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        ip: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        printer: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch(print) {
      if (print) {
        this.print = print
      }
      this.loading = true
      findAll('printConfigFactory', { 'print.id': this.print.id }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new PrintConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh(print) {
      this.page = 1
      this.fetch(print)
    },
    add() {
      const config = new PrintConfig()
      config.print = this.print
      this.data.push(config)
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      const saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('printConfigPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('printConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.data.splice(this.data.indexOf(row), 1)
      }
    }
  }
}
</script>